export const linuxForEveryoneShellsLogo = require("./linux4everyone_shells.png");
